import { CustomArray } from "./BaseModel";

// Threadクラスを定義
export class Thread {
  constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }
}

// Threadのコレクション
export class Threads extends CustomArray<Thread> {
}
